import { render, staticRenderFns } from "./JustDialV2.vue?vue&type=template&id=5eb050de&scoped=true"
import script from "./JustDialV2.vue?vue&type=script&lang=js"
export * from "./JustDialV2.vue?vue&type=script&lang=js"
import style0 from "./JustDialV2.vue?vue&type=style&index=0&id=5eb050de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb050de",
  null
  
)

export default component.exports